import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-user-share-review-link',
  templateUrl: './user-share-review-link.component.html',
  styleUrls: ['./user-share-review-link.component.scss']
})
export class UserShareReviewLinkComponent implements OnInit {
  sharePhone: string;
  reviewList: any;
  userData: any;
  descriptionText:any = "";
  showFullDescription: { [index: number]: boolean } = {};
  showFullRemarks: { [index: number]: boolean } = {};
  imgUrl = environment.ImageUrl;
  imagepreview: any;
  remarksText: any;
  showFullUserRemarks: { [index: number]: boolean } = {};
  userRemarksText: any;
  gfbid: any;
  is_paid: any;
  feedbackmessagesObj: any;
  is_paid_message: string;
  private modalRef;
  enteredPass: any;
  superAdminCode: any = '1111';
  google_name_link: any = "";
  image_link: any = "";

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
  ) {
    route.queryParams.subscribe(val => {
      this.sharePhone = atob(val['u'])
      this.getReviewList(this.sharePhone)
    });
   }

  ngOnInit(): void {
    // this.getReviewList(this.sharePhone)
  }

  getReviewList(phone){
    this.auth.getUserShareReview(phone).subscribe(
      (response: any) => {
        const currentTime = Math.round(new Date().getTime() / 1000);
        const responseData = response.body;
        this.google_name_link = responseData?.userData?.google_name_link;
        this.userData = responseData?.userData;
        this.reviewList = responseData?.reviewData;
        return responseData;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  toggleDescription(index: number, review) {
    this.showFullDescription[index] = !this.showFullDescription[index];
    this.descriptionText = review?.feedback_google?.description
  }
  
  toggleRemarks(index: number, review) {
    this.showFullRemarks[index] = !this.showFullRemarks[index];
    this.remarksText = review?.feedback_google?.remarks
  }

  toggleUserRemarks(index: number, review) {
    this.showFullUserRemarks[index] = !this.showFullUserRemarks[index];
    this.userRemarksText = review?.feedback_google?.user_remarks
  }

  saveFeedbackPayment(content, gfbid, is_paid, feedbackmessagesObj, type) {
    this.gfbid = gfbid
    this.is_paid = is_paid
    this.feedbackmessagesObj = feedbackmessagesObj
    
    this.is_paid_message = is_paid == 1 ? 'Approve?' : 'Dis-approve?'
    if(type == 1){
      this.modalService.open(content, { size: 'sm' });
    } else if(type == 2) {
      this.onPaymentApprove(content, gfbid, is_paid, feedbackmessagesObj, type)
    } else{
      // let nameData = this.getallname.filter(data => data.phno == feedbackmessagesObj.phone && data.name == feedbackmessagesObj.name )
      // nameData = nameData.length > 0 ? nameData[0] : {}
      // console.log(nameData,'----nameData-------');
      // return
      const saveObj = {
        gfbid,
        is_paid: is_paid,
        feedback_msg_id: feedbackmessagesObj.id
      }
      
      // return
      // this.onPaymentApprove(content, gfbid, is_paid, feedbackmessagesObj, type)
      // update approval
      if(feedbackmessagesObj?.manual_type == 1){
        this.auth.saveFeedbackPayment(saveObj).subscribe(
          (response: any) => {
            this.toastr.success(response.message);
            // this.ngOnInit();
            this.getReviewList(this.sharePhone)
            this.modalService.dismissAll();
          },
          (error) => {
            if (error.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            }
          }
        );
      }
      
      if(feedbackmessagesObj?.manual_type == 2){
        this.auth.saveFeedbackPayment_2(saveObj).subscribe(
          (response: any) => {
            this.toastr.success(response.message);
            // this.ngOnInit();
            this.getReviewList(this.sharePhone)
            this.modalService.dismissAll();
          },
          (error) => {
            if (error.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            }
          }
        );
      }
      
      if(feedbackmessagesObj?.manual_type == 3){
        this.auth.saveFeedbackPayment_3(saveObj).subscribe(
          (response: any) => {
            this.toastr.success(response.message);
            // this.ngOnInit();
            this.getReviewList(this.sharePhone)
            this.modalService.dismissAll();
          },
          (error) => {
            if (error.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            }
          }
        );
      }

    }
  }

  otp_modal(modal:any, form_id, action) {
    this.modalRef = this.modalService.open(modal, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
    // this.gfbid = form_id;
    // this.actionText = action;
    // this.is_paid_message = action;
  }

  open_google_name_link(modal: any) {
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' });
  }

  onOtpChange(event) { this.enteredPass = event; }

  onPaymentApprove(content, gfbid, is_client_side_paid, feedbackmessagesObj, type) {
    if (this.enteredPass == undefined || this.enteredPass == '') {
      this.toastr.error('Please enter password')
      return;
    }
    if((this.enteredPass) === this.superAdminCode) {
      this.saveFeedbackPayment(content, gfbid, is_client_side_paid, feedbackmessagesObj, 3)
    } else {
      this.toastr.error('Password is incorrect');
      return
    }
  }

  openGoogleNameLink() {
    if (this.enteredPass == undefined || this.enteredPass == '') {
      this.toastr.error('Please enter password')
      return;
    }
    if((this.enteredPass) === this.superAdminCode) {
      window.open(this.google_name_link, "_blank");
    } else {
      return this.toastr.error('Password is incorrect');
    }
  }

  viewImage(content: string, data) {
    this.imagepreview = data?.feedback_google?.image;
    this.image_link = data?.feedback_google?.image_link;
    this.modalService.open(content, { size: 'sm' });
    // this.verify_review(id)

  }

}
